
import { defineComponent, onMounted, ref } from 'vue'
import Card5 from '@/components/cards/Card5.vue';

//services
import pservice from '@/core/services/PublicService';

export default defineComponent({
    components: {
        Card5
    },
    setup() {
        const listEvents = ref<any>([])

        const getEventos = async () => {
            //loader.value = true
            //filter.value.periodo = gblPeriodo.value
            await pservice.getEvents()
            .then( (res) => {
                listEvents.value.length = 0
                listEvents.value = res.data
                //loader.value = false
            }).catch( ({response}) => {
                listEvents.value.length = 0
                //loader.value = false
                //errManager(response)
            }).finally(()=>{
                //loader.value = false
            })
        }

        onMounted(()=>{
            getEventos()
        })
        
        return {
            listEvents,

            //events
            getEventos
        }
    },
})
